import PropTypes from 'prop-types';

import { getClassNames } from '../../../utils/util';

import './tab-bar.scss';

const TabBar = ({ className, tab, tabs, onTabChange }) => {
  return (
    <div className={`tab-bar ${className}`}>
      {tabs.map((tabItem) => (
        <button
          key={tabItem}
          className={getClassNames('tab-bar__tab', { active: tab === tabItem })}
          onClick={() => onTabChange(tabItem)}
        >
          {tabItem}
        </button>
      ))}
    </div>
  );
};

TabBar.propTypes = {
  className: PropTypes.string,
  tab: PropTypes.string.isRequired,
  tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  onTabChange: PropTypes.func.isRequired,
};

TabBar.defaultProps = {
  className: '',
};

export default TabBar;
